const appIdRegex = /^\/apps\/([\w-]+)(\/|$)/

export const getAppId = (location: Location): string | null | undefined => {
  const match = new RegExp(appIdRegex).exec(location.pathname)

  return match && match[1]
}
